/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "a337884b5fb02119db2f661317837da629f9d227";
